var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFltForklift = function SvgFltForklift(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 84.3c3.9 0 7.1-3.2 7.1-7.1 0-3.9-3.2-7.1-7.1-7.1-3.9 0-7.1 3.2-7.1 7.1 0 3.9 3.1 7.1 7.1 7.1ZM99 84.3c3.899 0 7.099-3.2 7.099-7.1 0-3.9-3.2-7.1-7.1-7.1-3.9 0-7.1 3.2-7.1 7.1 0 3.9 3.2 7.1 7.1 7.1ZM32.2 55.8v19.9c0 1.6-1.3 2.8-2.8 2.8H6.6",
    stroke: "#2C112D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9 13.2v51.2H55l5.7 14.2h22.7L89 64.4h17.099l-1.5-5.8s-11.3-5.6-22.7-5.6H66.3M37.9 55.8h-5.7",
    stroke: "#2C112D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m49.2 64.4 2.5-20.3c.2-1.4 1.4-2.5 2.8-2.5h8.9c1.6 0 2.8 1.3 2.8 2.8v19.9M69.1 64.4H49.2M69.1 64.4v14.2",
    stroke: "#2C112D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgFltForklift;